import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.left}>
          &copy; 2026 Omari Sanders. All rights reserved.
        </div>
        <div className={styles.right}>
          <a href="https://www.linkedin.com/in/omarisanders" target="_blank" rel="noopener noreferrer" className={styles.link}>LinkedIn</a>
          <span className={styles.divider}>|</span>
          <a href="https://substack.com/@omarisanders" target="_blank" rel="noopener noreferrer" className={styles.link}>Substack</a>
        </div>
      </div>
    </footer>
  );
}
